/* eslint-disable max-len */
import dayjs from 'dayjs';
import { itemsOnPage } from './data';

export const convertFilters = ({ from, to, providers, statuses, gameTypes, page, userId }) => {
  // const params = new URLSearchParams();

  // gameTypes
  //   .filter(t => t.value !== 'all')
  //   .forEach(t => {
  //     if (gameTypes[0].active) params.append('gameType', String(t.value));
  //     else if (t.active) params.append('gameType', String(t.value));
  //   });

  // statuses
  //   .filter(t => t.value !== 'all')
  //   .forEach(t => {
  //     if (statuses[0].active) params.append('types', String(t.value));
  //     else if (t.active) params.append('types', String(t.value));
  //   });
  // providers
  //   .filter(t => t.value !== 'all')
  //   .forEach(t => {
  //     if (providers[0].active) params.append('provider', String(t.value));
  //     else if (t.active) params.append('provider', String(t.value));
  //   });
  // params.append('dateFrom', dayjs(from).format('YYYY-MM-DD'));
  // params.append('dateTo', dayjs(to).add(1, 'day').format('YYYY-MM-DD'));
  // params.append('page', String(page));
  // params.append('count', String(itemsOnPage));
  // params.append('target_id', String(userId));

  // return params;

  // const resultTypes = gameTypes
  //   .filter(gt => gt.active && gt.value !== 'all')
  //   .map(gt => gt.value)
  //   .join('');
  const resultStatuses = statuses
    .filter(s => s.active && s.value !== 0)
    .map(s => s.value)
    .join('');
  const resultProviders = providers
    .filter(p => p.active)
    .map(p => p.value)
    .join('');

  const finalResultProviders = resultProviders === 'PRAGMATIC' ? `${resultProviders},PRAGMATIC-NEW` : resultProviders;

  return {
    dateFrom: dayjs(from).format('YYYY-MM-DD HH:mm:ss'),
    dateTo: dayjs(to).add(1, 'day').format('YYYY-MM-DD HH:mm:ss'),
    provider: finalResultProviders,
    types: resultStatuses,
    page,
    count: itemsOnPage,
    user_id: userId,
  };
};
